import { createClient } from '@supabase/supabase-js';
import type { Database } from './database.types';

const url = import.meta.env.VITE_SUPABASE_URL;
const anonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!url) throw new Error('VITE_SUPABASE_URL is not defined. Check .env.local');
if (!anonKey) throw new Error('VITE_SUPABASE_ANON_KEY is not defined. Check .env.local');

/**
 * Singleton Supabase client.
 * Generic is bound to generated `Database` types — every query is type-safe.
 *
 * Auth is browser-side: persists session in localStorage and auto-refreshes tokens.
 */
export const supabase = createClient<Database>(url, anonKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
  },
});

export type SupabaseClient = typeof supabase;
